module.exports = __webpack_public_path__ + "static/media/wmgr_headset.610ad51a.png";